import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import CRMNav from "./CRMNav";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const formatFecha = (str) => {
  if (!str) return "—";
  const d = new Date(str);
  if (isNaN(d.getTime())) return "—";
  return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
};

const ProspeccionDescartados = () => {
  const history = useHistory();
  const [items, setItems]     = useState([]);
  const [stats, setStats]     = useState({ por_origen: [], por_segmento: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [periodo, setPeriodo] = useState("90"); // últimos 90 días
  const [fSegmento, setFSegmento] = useState("");
  const [fOrigen, setFOrigen]     = useState("");
  const [segmentos, setSegmentos] = useState([]);

  useEffect(() => {
    axios.get(`${BASE}/buscar_segmentos.php`)
      .then((r) => { if (Array.isArray(r.data)) setSegmentos(r.data); })
      .catch(() => {});
  }, []);

  const fetchData = useCallback(() => {
    setLoading(true);
    const fd = new FormData();
    fd.append("periodo_dias", periodo);
    if (fSegmento) fd.append("segmento", fSegmento);
    if (fOrigen)   fd.append("origen", fOrigen);
    axios.post(`${BASE}/prospectos_listar_descartados.php`, fd)
      .then(r => {
        if (r.data?.success) {
          setItems(r.data.descartados || []);
          setStats(r.data.stats     || { por_origen: [], por_segmento: [], total: 0 });
        } else toast.error(r.data?.mensaje || "Error al cargar");
      })
      .catch(() => toast.error("Error de conexión"))
      .finally(() => setLoading(false));
  }, [periodo, fSegmento, fOrigen]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const reactivar = async (id) => {
    const opciones = ["sin_tocar", "esperando_respuesta", "frio", "en_dialogo", "en_pausa"];
    const estado = window.prompt(
      "Reactivar a qué estado?\n\n" +
      "• sin_tocar\n• esperando_respuesta\n• frio\n• en_dialogo\n• en_pausa",
      "sin_tocar"
    );
    if (!estado) return;
    if (!opciones.includes(estado)) { toast.error("Estado inválido"); return; }
    try {
      const fd = new FormData();
      fd.append("id", id);
      fd.append("estado_retorno", estado);
      const r = await axios.post(`${BASE}/prospectos_reactivar.php`, fd);
      if (r.data?.success) { toast.success("Reactivado"); fetchData(); }
      else                  toast.error(r.data?.mensaje || "Error");
    } catch { toast.error("Error de conexión"); }
  };

  return (
    <div style={{ padding: "28px 32px", maxWidth: 1200, margin: "0 auto" }}>
      <CRMNav />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 22 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>🗑 Descartados</h2>
          <p style={{ margin: "2px 0 0", color: "#888", fontSize: 13 }}>
            Total: {stats.total} en los últimos {periodo} días
          </p>
        </div>
        <button
          onClick={() => history.push("/dashboard/crm/prospeccion")}
          style={{ background: "none", border: "1px solid #e0d6dc", color: "#888", padding: "7px 14px", borderRadius: 6, fontSize: 12, cursor: "pointer" }}
        >
          ← Volver al embudo
        </button>
      </div>

      {/* Filtros */}
      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        <select style={sel} value={periodo} onChange={(e) => setPeriodo(e.target.value)}>
          <option value="30">Últimos 30 días</option>
          <option value="90">Últimos 90 días</option>
          <option value="180">Últimos 6 meses</option>
          <option value="365">Último año</option>
        </select>
        <select style={sel} value={fSegmento} onChange={(e) => setFSegmento(e.target.value)}>
          <option value="">Todos los segmentos</option>
          {segmentos.map((s) => <option key={s.id} value={s.nombre}>{s.nombre}</option>)}
        </select>
        <input style={sel} value={fOrigen} onChange={(e) => setFOrigen(e.target.value)} placeholder="Filtrar por origen…" />
      </div>

      {/* Stats */}
      {stats.por_origen.length > 0 && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 20 }}>
          <StatBox titulo="Tasa de descarte por origen" items={stats.por_origen} />
          <StatBox titulo="Tasa de descarte por segmento" items={stats.por_segmento} />
        </div>
      )}

      {/* Tabla */}
      {loading ? (
        <p style={{ textAlign: "center", color: "#aaa", padding: 40 }}>Cargando…</p>
      ) : items.length === 0 ? (
        <p style={{ textAlign: "center", color: "#aaa", padding: 40 }}>Sin descartados en el período.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse", background: "#fff", borderRadius: 10, overflow: "hidden", boxShadow: "0 1px 3px rgba(159,0,89,0.05)" }}>
          <thead>
            <tr>
              {["Empresa", "Segmento", "Origen", "Descartado", "Motivo", ""].map(h => (
                <th key={h} style={{ padding: "10px 14px", fontSize: 11, fontWeight: 700, color: "#9f0059", textTransform: "uppercase", letterSpacing: "0.06em", textAlign: "left", borderBottom: "1.5px solid #f0e6ec", background: "#fdf0f6" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map(p => (
              <tr key={p.id} style={{ borderBottom: "1px solid #f7f4f6" }}>
                <td style={td}><strong>{p.empresa}</strong></td>
                <td style={td}>{p.segmento || p.segmento_prospeccion}</td>
                <td style={td}>{p.origen}</td>
                <td style={td}>{formatFecha(p.fecha_descarte)}</td>
                <td style={{ ...td, maxWidth: 280 }} title={p.motivo_descarte}>
                  <span style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {p.motivo_descarte}
                  </span>
                </td>
                <td style={td}>
                  <button onClick={() => history.push(`/dashboard/crm/prospeccion/detalle/${p.id}`)} style={btnSmall}>Ver</button>
                  <button onClick={() => reactivar(p.id)} style={{ ...btnSmall, color: "#166534", marginLeft: 6 }}>Reactivar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const StatBox = ({ titulo, items }) => (
  <div style={{ background: "#fff", border: "1.5px solid #f0e6ec", borderRadius: 10, padding: "14px 18px" }}>
    <div style={{ fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>{titulo}</div>
    {items.length === 0 ? (
      <p style={{ color: "#bbb", fontSize: 12, margin: 0 }}>Sin datos</p>
    ) : items.map((s, i) => (
      <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: 13 }}>
        <span style={{ color: "#222" }}>{s.label || s.origen || s.segmento || s.segmento_prospeccion || "—"}</span>
        <span style={{ color: "#9f0059", fontWeight: 700 }}>
          {s.tasa}% ({s.descartados} de {s.total})
        </span>
      </div>
    ))}
  </div>
);

const sel = { padding: "8px 12px", border: "1.5px solid #e0d6dc", borderRadius: 7, fontSize: 13, background: "#fff", color: "#222", outline: "none", cursor: "pointer", minWidth: 160 };
const td  = { padding: "10px 14px", fontSize: 13, color: "#222", verticalAlign: "middle" };
const btnSmall = { background: "none", border: "1px solid #e0d6dc", color: "#9f0059", padding: "3px 10px", borderRadius: 5, fontSize: 11, fontWeight: 600, cursor: "pointer" };

export default ProspeccionDescartados;
